/**
 * Cómo quedaría el lead con el mapeo que se está editando.
 *
 * Es la parte que evita descubrir el error una semana después: se ve el
 * resultado antes de activar, no cuando ya entraron cien leads mal armados.
 */
export default function LeadPreview({ preview, isLoading }) {
    if (isLoading) {
        return <p className="text-xs text-gray-400 p-4">Calculando…</p>;
    }

    if (!preview) {
        return (
            <p className="text-xs text-gray-400 p-4">
                Elegí al menos un campo para ver el lead que se crearía.
            </p>
        );
    }

    const { attributes = {}, custom = [], existing_contact: existing } = preview;

    const LABELS = {
        first_name: 'Nombre',
        last_name: 'Apellido',
        email: 'Correo',
        phone: 'Teléfono',
        company: 'Empresa',
        position: 'Cargo',
        territory: 'País',
        industry: 'Sector',
        address: 'Dirección',
    };

    const rows = Object.entries(attributes).filter(([, v]) => v);

    return (
        <div className="p-4 space-y-4">
            {existing && (
                <div className="flex gap-2 p-3 rounded-lg bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800/50">
                    <span className="material-symbols-outlined text-amber-600 text-lg shrink-0">merge</span>
                    <div className="text-xs text-amber-800 dark:text-amber-200">
                        <p className="font-semibold">Ya existe un contacto con estos datos</p>
                        <p className="mt-0.5">
                            No se creará uno nuevo: se completarán los campos vacíos de{' '}
                            <strong>{existing.full_name || existing.email}</strong> sin pisar lo que ya tenga.
                        </p>
                    </div>
                </div>
            )}

            {rows.length === 0 && custom.length === 0 ? (
                <p className="text-xs text-gray-400">El mapeo actual no extrae ningún dato de este envío.</p>
            ) : (
                <>
                    <dl className="space-y-1.5">
                        {rows.map(([key, value]) => (
                            <div key={key} className="flex gap-3 text-xs">
                                <dt className="w-24 shrink-0 text-gray-400">{LABELS[key] || key}</dt>
                                <dd className="font-medium dark:text-white break-words min-w-0">{value}</dd>
                            </div>
                        ))}
                    </dl>

                    {custom.length > 0 && (
                        <div className="pt-3 border-t border-gray-100 dark:border-gray-800">
                            <p className="text-[11px] uppercase tracking-wide text-gray-400 mb-1.5">
                                Campos personalizados
                            </p>
                            <dl className="space-y-1.5">
                                {custom.map((c) => (
                                    <div key={c.key} className="flex gap-3 text-xs">
                                        <dt className="w-24 shrink-0 text-gray-400 truncate" title={c.label}>{c.label}</dt>
                                        <dd className="font-medium dark:text-white break-words min-w-0">{c.value}</dd>
                                    </div>
                                ))}
                            </dl>
                        </div>
                    )}
                </>
            )}
        </div>
    );
}
